import { render, staticRenderFns } from "./interview_table.vue?vue&type=template&id=5b0dc79c"
import script from "./interview_table.vue?vue&type=script&lang=ts"
export * from "./interview_table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports